import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { DepartureTicketInfo } from '../../schema/departure-ticket-info';
import { DepartureTicketInfoProxyService } from '../departure-ticket-info-proxy/departure-ticket-info-proxy.service';

@Injectable({
  providedIn: 'root'
})
export class DepartureTicketInfoService {
  callcardId: string = null;
  departureTicketInfo: DepartureTicketInfo = null;

  constructor(private departureTicketInfoProxy: DepartureTicketInfoProxyService) {}

  getDepartureTicketInfo(callcardId: string): Observable<DepartureTicketInfo> {
    if (this.callcardId == callcardId) {
      return of(this.departureTicketInfo);
    } else {
      this.callcardId = null;
      this.departureTicketInfo = null;

      return this.departureTicketInfoProxy.getDepartureTicketInfo(callcardId).pipe(
        tap(departureTicketInfo => {
          this.callcardId = callcardId;
          this.departureTicketInfo = departureTicketInfo;
        })
      );
    }
  }
}
